import apiSlice from "./ApiSlice";

export const questionBankApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL Questions WITH PAGINATION
    getAllQuestionsWithPagination: builder.query({
      providesTags: ["question", "batches"],
      query: (body) => {
        return {
          url: "/question",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addQuestions: builder.mutation({
      invalidatesTags: ["question"],
      query: (body) => {
        return {
          url: "/question/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteQuestions: builder.mutation({
      invalidatesTags: ["question"],
      query: ({ id }) => {
        return {
          url: `/question/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET CHAPTER BY ID
    getQuestionsById: builder.query({
      providesTags: ["question"],
      query: ({ id }) => {
        return {
          url: `/question/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editQuestions: builder.mutation({
      invalidatesTags: ["question"],
      query: ({ body, id }) => {
        return {
          url: `/question/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // GET ALL Questions WITH PAGINATION
    getAllbatchesAssigmentsWithPagination: builder.query({
      providesTags: ["question", "batches"],
      query: ({ body, id }) => {
        return {
          url: `assignment/batch/${id}/get-batch-assignments`,
          method: "POST",
          body,
        };
      },
    }),

    //Add Remark
    addQuestionRemark: builder.mutation({
      invalidatesTags: ["question"],
      query: ({ body, questionId, studentId, batchId }) => {
        return {
          url: `assignment/add-remark/${questionId}/batch/${batchId}/student/${studentId}`,
          method: "PUT",
          body,
        };
      },
    }),
    // GET CHAPTER BY ID
    getStudentThoseNotCompleteAssignment: builder.query({
      providesTags: ["question"],
      query: ({ id }) => {
        return {
          url: `/assignment/${id}/not-submitted-assignment`,
          method: "GET",
        };
      },
    }),
    
  }),
});

export const {
  useGetAllQuestionsWithPaginationQuery,
  useAddQuestionsMutation,
  useDeleteQuestionsMutation,
  useEditQuestionsMutation,
  useGetQuestionsByIdQuery,
  useGetAllbatchesAssigmentsWithPaginationQuery,
  useAddQuestionRemarkMutation,
  useGetStudentThoseNotCompleteAssignmentQuery
} = questionBankApi;
